@if (canViewTable) {
	<div class="sticky-header-container">
		<div class="row mb-1 justify-content-end">
			@if (secondButtonTxt && canShowSecondButton) {
				<div class="col-sm-4 col-12">
					<button
						[disabled]="secondButtonDisabled"
						class="form-control btn btn-table btn-{{ secondButtonClass }}"
						(click)="secondButtonEvent($event)">
						{{ secondButtonTxt | translate }}
					</button>
				</div>
			}
			<!--	<div class='col-sm-4 col-12' *ngIf='actionButtonTxt'>-->
			<!--		<button-->
			<!--			[disabled]='actionButtonDisabled'-->
			<!--			class='form-control btn btn-table btn-{{ actionButtonClass }}'-->
			<!--			(click)='actionButtonEvent($event)'-->
			<!--		>-->
			<!--			{{ actionButtonTxt | translate }}-->
			<!--		</button>-->
			<!--	</div>-->
		</div>
		@if (!simple) {
			<div class="row mb-1 gx-2 gy-2 align-items-stretch">
				<!-- Mobile: Pulsante Seleziona tutto a larghezza piena -->
				@if (actionButtonTxt && canShowActionButton) {
					<div class="col-12 mb-2 d-lg-none">
						<button
							[disabled]="actionButtonDisabled"
							class="btn btn-table btn-{{ actionButtonClass }} w-100"
							(click)="actionButtonEvent($event)">
							{{ actionButtonTxt | translate }}
						</button>
					</div>
				}
				<!-- Desktop: Layout normale -->
				@if (actionButtonTxt) {
					<div class="col-xxl-2 col-lg-2 col-4 d-none d-lg-block">
						<button
							[disabled]="actionButtonDisabled"
							class="form-control btn btn-table btn-{{ actionButtonClass }}"
							(click)="actionButtonEvent($event)">
							{{ actionButtonTxt | translate }}
						</button>
					</div>
				}
				@if (visibleActions.length === 1) {
					<div class="col-sm-2 col-lg-1 col-xxl-1 col-4">
						<button
							[class]="'w-100 h-100 btn btn-' + visibleActions[0].icon?.class"
							(click)="visibleActions[0].click()"
							[ngbTooltip]="visibleActions[0].txt | translate"
							[disabled]="visibleActions[0].disabled()">
							<fa-icon [icon]="visibleActions[0].icon.name"></fa-icon>
						</button>
					</div>
				}
				@if (visibleActions.length > 1) {
					<div class="col-sm-2 col-lg-1 col-xxl-1 col-4">
						<div ngbDropdown class="h-100">
							<button
								ngbDropdownToggle
								id="action-core-table"
								class="btn-icon btn btn-primary btn-round h-100 w-100"
								type="button"
								rippleEffect>
								<!--				<span [data-feather]="'grid'"></span>-->
								<fa-icon icon="cogs"></fa-icon>
							</button>
							<div ngbDropdownMenu aria-labelledby="action-core-table">
								@for (action of visibleActions; track action) {
									<a ngbDropdownItem [disabled]="action.disabled()" (click)="action.click()">
										@if (action.icon) {
											@if (action.icon?.class !== '') {
												<fa-icon [icon]="action.icon.name" [class]="'text-' + action.icon.class"></fa-icon>
											} @else {
												<fa-icon [icon]="action.icon.name"></fa-icon>
											}
										}
										<span class="ms-1">{{ action.txt | translate }}</span>
									</a>
								}
							</div>
						</div>
					</div>
				}
				<div class="col-sm-2 col-lg-1 col-md-1 col-4">
					<ng-select
						class="core-table-page-size"
						[items]="pageSizeOptions"
						[(ngModel)]="pageSize"
						[clearable]="false"
						[searchable]="false"
						[appendTo]="'body'"
						[placeholder]="''"
						(ngModelChange)="onPageSizeChanged()">
					</ng-select>
				</div>
				<div class="col-sm-2 col-lg-1 col-xxl-1 col-4">
					<button class="form-control btn-light btn-table" (click)="onBtnExport(exportOffset)">CSV</button>
				</div>
				<div class="col-12 col-md col-lg">
					<input
						type="text"
						[id]="filterId"
						class="form-control"
						[placeholder]="'common_placeholder_search' | translate"
						(input)="onFilterTextBoxChanged()" />
				</div>
				@if (filterOptions.length > 0) {
					<div class="col-12 col-lg-3">
						<ng-select
							[items]="filterOptions"
							bindLabel="label"
							bindValue="value"
							[(ngModel)]="filterValue"
							(change)="onFilterSelectChanged()"
							[clearable]="false"
							[placeholder]="filterPlaceholder | translate">
						</ng-select>
					</div>
				}
			</div>
		}
		<!-- Mobile Sort Dropdown -->
		<div class="row d-lg-none mb-2 gx-2">
			@if (rowSelection) {
				<div class="col-5">
					<div class="d-flex align-items-center justify-content-center bg-white border rounded px-3 h-100">
						<div class="form-check mb-0">
							<input
								class="form-check-input"
								type="checkbox"
								[checked]="isAllSelected"
								(change)="toggleAllOptions()"
								id="mobileSelectAll" />
							<label class="form-check-label ms-1" for="mobileSelectAll">
								{{ 'common_label_all' | translate }}
							</label>
						</div>
					</div>
				</div>
			}
			<div class="col">
				<div ngbDropdown class="d-inline-block w-100">
					<button
						class="btn btn-outline-primary w-100 d-flex justify-content-between align-items-center"
						id="mobileSortDropdown"
						ngbDropdownToggle>
						<span><fa-icon icon="sort" class="me-1"></fa-icon> {{ 'Ordina per' | translate }}</span>
					</button>
					<div ngbDropdownMenu aria-labelledby="mobileSortDropdown" class="w-100">
						@for (col of visibleColumns; track col) {
							<button ngbDropdownItem (click)="onMobileSort(col)" class="d-flex justify-content-between align-items-center">
								{{ col.headerName || col.getColDef?.().headerName | translate }}
								&nbsp;
								@if (isSorted(col)) {
									<fa-icon [icon]="getSortIcon(col)"></fa-icon>
								}
							</button>
						}
					</div>
				</div>
			</div>
		</div>
	</div>
}

@if (showGrid && canViewTable) {
	<ag-grid-angular
		style="width: 100%"
		[style.height]="effectiveHeight"
		class="ag-theme-material"
		[rowData]="rowData"
		[columnDefs]="columnDefs"
		(gridReady)="onGridReady($event)"
		(gridSizeChanged)="onGridSizeChanged()"
		(sortChanged)="onSortChanged()"
		(selectionChanged)="emitRows($event)"
		[animateRows]="true"
		[pagination]="!simple && !serverSidePagination"
		[localeText]="tableLanguage"
		[paginationPageSize]="30"
		[paginationPageSizeSelector]="[30, 100, 300, 500]"
		[headerHeight]="headerHeight"
		[gridOptions]="gridOptions"
		[rowSelection]="rowSelection"
		[domLayout]="effectiveDomLayout"
		[editType]="editType"
		(rowValueChanged)="emitEditedRow($event)"
		(cellValueChanged)="onCellValueChanged($event)"
		(filterChanged)="saveFilterModel()"
		(firstDataRendered)="onFirstDataRendered($event)"
		(rowDataUpdated)="onRowDataUpdatedInternal($event)"
		(cellClicked)="onCellClicked($event)"
		[enableCellTextSelection]="true">
	</ag-grid-angular>
}

@if (!canViewTable) {
	<div class="text-center text-muted py-3">
		{{ 'Non hai i permessi per visualizzare questa lista' | translate }}
	</div>
}

@if (!simple && serverSidePagination && canViewTable) {
	<div class="d-flex flex-wrap justify-content-center align-items-center gap-1 py-1">
		<ngb-pagination
			[collectionSize]="totalRecords"
			[pageSize]="pageSize"
			[page]="first / pageSize + 1"
			[maxSize]="5"
			[rotate]="true"
			[boundaryLinks]="true"
			size="sm"
			class="mb-0"
			(pageChange)="onServerPagePick($event)"></ngb-pagination>
		@if (totalRecords > 0) {
			<small class="text-muted">{{ first + 1 }} - {{ min(first + pageSize, totalRecords) }} di {{ totalRecords }}</small>
		}
	</div>
}

<!--stopEditingWhenCellsLoseFocus=true-->
